import frontEndTraceLog from "@/actions/system/frontEndTraceLog";
import { clearTraceLogQueue, getTraceLogQueue, initTraceLogQueue } from "@/stores/useTraceLogQueueStore";

const key = "[FrontEndTraceLog]";
const TRACE_INTERVAL = 5 * 60 * 1000;

let timerId: number | null = null;
let isRunning = false;

export const processTraceLogQueue = async (): Promise<void> => {
  const logs = getTraceLogQueue();

  console.log(`${key} Processing trace logs:`, logs);
  if (logs.length === 0) return;

  try {
    await frontEndTraceLog(logs);
    clearTraceLogQueue();
  } catch (error) {
    console.error(`${key} Failed to report trace logs:`, error);
  }
};

export const scheduleNextTrace = (): void => {
  if (!isRunning) return;

  timerId = window.setTimeout(() => {
    processTraceLogQueue();
    scheduleNextTrace();
  }, TRACE_INTERVAL);
};

export const startTraceLog = (): void => {
  if (isRunning) return;

  isRunning = true;
  console.log(`${key} Started`);
  scheduleNextTrace();
};

export const stopTraceLog = (): void => {
  if (timerId) {
    clearTimeout(timerId);
    timerId = null;
  }
  isRunning = false;
};

export const initTraceLog = (): void => {
  initTraceLogQueue();
  startTraceLog();
};

export const resetTraceLog = (): void => {
  stopTraceLog();
  clearTraceLogQueue();
  startTraceLog();
};
